import React from "react";

const Incorrect = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 48 48"
    className={props.className}

  >
    <g data-name="Group 994" transform="translate(-750.333 -546.333)">
      <g
        fill="#a31621"
        stroke="#283044"
        strokeWidth="1"
        data-name="Ellipse 257"
        transform="translate(751.333 547.333)"
      >
        <circle cx="23" cy="23" r="23" stroke="none"></circle>
        <circle cx="23" cy="23" r="23.5" fill="none"></circle>
      </g>
      <g data-name="Group 974" transform="translate(759.974 555.975)">
        <path
          fill="#eee5e9"
          d="M14.5 19.139L4.639 29 0 24.36l9.861-9.86L0 4.639 4.639 0 14.5 9.86 24.361 0 29 4.639 19.139 14.5 29 24.36 24.361 29z"
          data-name="Union 49"
          transform="translate(.359 .359)"
        ></path>
      </g>
    </g>
  </svg>
  );
}

export default Incorrect